import * as proto from 'src/proto/compiled-protos';
import { Observable, map } from "rxjs";
import { IndeterminatePaginatorData } from "src/app/general/components/indeterminate-paginator/indeterminate-paginator-model";
import { BackendService } from "../../services/backend.service";
import { DataTableColumn, StringColumn } from "src/app/general/components/data-table/data-table-column";
import { LocationsModel } from "./locations-model";
import { Util } from 'src/app/general/util/util';
import { Formatter } from '../../util/formatter';

export class InactiveLocationsModel implements LocationsModel {
  backendService: BackendService;

  constructor(backendService: BackendService) {
    this.backendService = backendService;
  }

  fetchData(continuationToken: string | null | undefined): Observable<IndeterminatePaginatorData<proto.waiternow.common.ILocationProto>> {
    return this.backendService.findInactiveLocationsReturnObservable(continuationToken)
      .pipe(
        map(locations  => {
          const paginatorData: IndeterminatePaginatorData<proto.waiternow.common.ILocationProto> = {data: [], continuationToken: continuationToken};
          if (locations) {
            paginatorData.data = locations.locations;
            paginatorData.continuationToken = locations.continuationToken;
          }
          return paginatorData;
        })
      );
  }

  getAdditionalColumns(): Array<DataTableColumn<proto.waiternow.common.ILocationProto>> {
    return [
      new StringColumn(
        /* name= */ 'country',
        /* translateId= */ 'country',
        /* valueExtractor= */  location => Formatter.formatCountry(location.address?.structuredAddress?.country),
        /* hideInCompactMode= */ true),
      new StringColumn(
        /* name= */ 'lastPaidOrder',
        /* translateId= */ 'last_paid_order',
        /* valueExtractor= */  location => location.redundantData?.lastPaidOrderOn ? Formatter.formatTimestampProto(location.redundantData.lastPaidOrderOn) : ''),
      ];
  }
}
